import { useSelector } from 'react-redux';
import { selectRace, selectAge, selectBehaviourDesc } from '@store/order/selectors';



const AnimalInfo = (): JSX.Element => {

	const race = useSelector(selectRace);
	const age = useSelector(selectAge);
	const behaviourDesc = useSelector(selectBehaviourDesc);

	return (
		<>
			<div className='order-summary-element'>

				<h2>Rasa</h2>

				<div className='summary-property'>
					<p>{race ? race : '-'}</p>
				</div>

			</div>


			<div className='order-summary-element'>

				<h2>Věk</h2>

				<div className='summary-property'>
					<p>{age ? age : '-'}</p>
				</div>

			</div>


			<div className='order-summary-element'>

				<h2>Povaha</h2>

				<div className='summary-property'>
					<p>{behaviourDesc ? behaviourDesc : '-'}</p>
				</div>

			</div>
		</>
	);
};

export default AnimalInfo;